// @flow

import {defineMessages, FormattedMessage} from 'react-intl';
import * as React from 'react';
import Box from 'sail/Box';
import {Caption} from 'sail/Text';

const footnoteMessages = defineMessages({
  betaCountryFootnote: {
    id: 'docsShell.Terminal.footnote.betaCountryFootnote',
    description:
      'Footnote stipulating that Terminal is in beta for this country',
    defaultMessage: 'Terminal is currently in beta in this country.',
  },
  betaIntegrationShapeFootnote: {
    id: 'docsShell.Terminal.footnote.betaIntegrationShapeFootnote',
    description:
      'Footnote stipulating that this Terminal integration shape is currently in beta',
    defaultMessage: 'This Terminal integration shape is currently in beta.',
  },
});

export const TerminalBetaFootnoteRef = ({
  betaIntegrationShape,
  betaCountry,
}: {
  betaIntegrationShape?: boolean,
  betaCountry?: boolean,
}) => (
  <>
    {betaIntegrationShape && <Caption>*</Caption>}
    {betaCountry && (
      <Caption>
        <sup>+</sup>
      </Caption>
    )}
  </>
);

export const TerminalBetaFootnote = ({
  betaIntegrationShape,
  betaCountry,
}: {
  betaIntegrationShape?: boolean,
  betaCountry?: boolean,
}) => (
  <>
    {betaCountry && (
      <Box>
        <TerminalBetaFootnoteRef betaCountry />
        <Caption>
          <FormattedMessage {...footnoteMessages.betaCountryFootnote} />
        </Caption>
      </Box>
    )}
    {betaIntegrationShape && (
      <Box>
        <TerminalBetaFootnoteRef betaIntegrationShape />
        <Caption>
          <FormattedMessage
            {...footnoteMessages.betaIntegrationShapeFootnote}
          />
        </Caption>
      </Box>
    )}
  </>
);
